import { render, staticRenderFns } from "./CustomInvoice.vue?vue&type=template&id=d88c5f62&"
import script from "./CustomInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports